import React, { useContext } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { StudentContext } from '../StudentContext';
import './BlockList.css';

const getBlockDisplayName = (blockId) => {
  switch (blockId) {
    case 'khai-tam':
      return 'Khối Khai Tâm';
    case 'ruoc-le':
      return 'Khối Rước Lễ';
    case 'them-suc':
      return 'Khối Thêm Sức';
    case 'bao-dong':
      return 'Khối Bao Đồng';
    default:
      return blockId;
  }
};

const BlockList = () => {
  const { allBlocks, blocks, isLoading } = useContext(StudentContext);

  if (isLoading) {
    return <div className="loading-message">Đang tải dữ liệu khối...</div>;
  }

  const visibleBlockIds = Object.keys(blocks);
  const allBlockIds = Object.keys(allBlocks);

  if (allBlockIds.length === 0) {
    return <div className="no-data-message">Không có khối nào để hiển thị.</div>;
  }

  return (
    <div className="block-list-container">
      <div className="block-nav">
        {allBlockIds.map((blockId) => {
          const isAccessible = visibleBlockIds.includes(blockId);
          return (
            <NavLink
              key={blockId}
              to={`/main/class-list/${blockId}`}
              className={({ isActive }) =>
                isActive && isAccessible ? 'active' : isAccessible ? '' : 'disabled'
              }
            >
              {getBlockDisplayName(blockId)}
            </NavLink>
          );
        })}
      </div>
      <div className="block-content">
        <Outlet />
      </div>
    </div>
  );
};

export default BlockList;